export enum SpaceType {
  MEETING_ROOM = 'meetingRoom',
  DAY_OFFICE = 'dayOffice',
  DAY_COWORKING = 'dayCoworking',
  TRAINING_ROOM = 'trainingRoom',
}

export const productId = {
  [SpaceType.MEETING_ROOM]: 3000,
  [SpaceType.DAY_OFFICE]: 8000,
  [SpaceType.DAY_COWORKING]: 14000
}

const spaceTypes = Object.freeze({
  meetingRoom: {
    name: 'Meeting room',
    path: 'meeting-room',
    l10n: SpaceType.MEETING_ROOM,
    imageUrl: 'https://assets.iwgplc.com/image/upload/c_fill,f_auto,q_auto,w_304,h_304,g_auto:subject/v1695984019/WebsiteImagery/Brands/Regus/Solutions-Imagery/Meeting-Rooms/Card-Stacked/Meeting_Rooms_Card_Stacked_1.png'
  },
  trainingRoom: {
    name: 'Training room',
    path: 'training-room',
    l10n: SpaceType.TRAINING_ROOM,
    imageUrl: 'src="https://assets.iwgplc.com/image/upload/c_fill,f_auto,q_auto,w_304,h_304,g_auto:subject/v1695984204/WebsiteImagery/Brands/Regus/Solutions-Imagery/Meeting-Rooms/Card-Stacked/Meeting_Rooms_Card_Stacked_3.png"'
  },
  dayOffice: {
    name: 'Day Office',
    path: 'day-office',
    l10n: SpaceType.DAY_OFFICE,
    imageUrl: 'https://assets.iwgplc.com/image/upload/c_fill,f_auto,q_auto,w_304,h_304,g_auto:subject/v1695907382/WebsiteImagery/Brands/Regus/Solutions-Imagery/Office-Space/Card-Stacked/Office_Space_Card_Stacked_3.png'
  },
  dayCoworking: {
    name: 'Day Coworking',
    path: 'day-coworking',
    l10n: SpaceType.DAY_COWORKING,
    imageUrl: 'https://assets.iwgplc.com/image/upload/c_fill,f_auto,q_auto,w_304,h_304,g_auto:subject/v1695991381/WebsiteImagery/Brands/Regus/Solutions-Imagery/Coworking/Card-Stacked/Coworking_Card_Stacked_2.png'
  },
});

const spaceTypeMap: Record<string, SpaceType> = {
  'meeting-room': SpaceType.MEETING_ROOM,
  'day-office': SpaceType.DAY_OFFICE,
  'day-coworking': SpaceType.DAY_COWORKING,
  'training-room': SpaceType.TRAINING_ROOM,
};

export const getSpaceTypeFromUrl = (urlPart: string): SpaceType | undefined => {
  const cleaned = urlPart.replace(/^\//, '');
  return spaceTypeMap[cleaned];
}

export default spaceTypes;
